import { ApiError, ApiResult } from '@models/api';

import { UseQueryOptions, useQuery } from '@hooks/react-query';
import { PrivyRegistrationStatusResponse } from '../models';

function useRGetPrivyRegistrationStatus(
  options: UseQueryOptions<
    ApiResult<PrivyRegistrationStatusResponse>,
    ApiError
  > = {},
  application_id: number,
) {
  return useQuery<ApiResult<PrivyRegistrationStatusResponse>, ApiError>({
    queryKey: ['digisign/v1/register/status', { application_id }],
    ...options,
  });
}

export default useRGetPrivyRegistrationStatus;
